import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface InventoryCategoryMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allInventoryCategoryList: any[];
}

const initialState: InventoryCategoryMasterState = {
  data: null,
  currentPage: null,
  totalRecords: null,
  totalPages: null,
  allInventoryCategoryList: [],
};

export const inventoryCategoryMasterSlice = createSlice({
  name: "inventoryCategoryMaster",
  initialState,
  reducers: {
    setInventoryCategoryMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryCategoryMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPage;
      state.currentPage = action.payload.data.currentPage;
    },
    setInventoryCategoryMasterList: (state, action) => {
      state.allInventoryCategoryList = action.payload.data;
    },
    reset: () => initialState,
  },
});

export const {
  setInventoryCategoryMaster,
  setInventoryCategoryMasterBySearch,
  setInventoryCategoryMasterList,
  reset,
} = inventoryCategoryMasterSlice.actions;

export const getInventoryCategoryMasterDetails = (state: RootState) =>
  state.inventoryCategoryMaster.data;
export const getInventoryCategoryMasterTotalRecords = (state: RootState) =>
  state.inventoryCategoryMaster.totalRecords;
export const getInventoryCategoryMasterSearch = (state: RootState) =>
  state.inventoryCategoryMaster.data;
export const getInventoryCategoryMasterList = (state: RootState) =>
  state.inventoryCategoryMaster.allInventoryCategoryList;

export default inventoryCategoryMasterSlice.reducer;
